<li
  class="nav-item navbar-dropdown dropdown-user dropdown animate__animated animate__bounceInDown animate__delay-0-4s"
>
  <a
    id="user-profile"
    class="nav-link dropdown-toggle hide-arrow"
    href="javascript:void(0);"
    data-bs-toggle="dropdown"
    ngbTooltip="{{ 'topMenu.profile' | translate }}"
  >
    <div class="avatar avatar-online">
      <img
        [src]="thisUser.imageurl"
        [alt]="thisUser.username"
        (error)="thisUser.imageurl = '../../assets/img/avatars/no-image.png'"
        class="rounded-circle"
      />
    </div>
  </a>
  <ul class="dropdown-menu dropdown-menu-end">
    <li>
      <a class="dropdown-item">
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <div class="avatar avatar-online mt-1 mb-2">
              <img
                [src]="thisUser.imageurl"
                alt="thisUser.Username"
                class="rounded-circle"
              />
            </div>
            <div>
              <a
                id="change-mode"
                class="nav-link style-switcher-toggle hide-arrow"
                href="javascript:void(0);"
                [ngClass]="{ 'dark-mode': isDarkMode }"
                (click)="isDarkMode = !isDarkMode"
              >
                <div class="theme-toggle">
                  <div class="toggle-circle">
                    <i class="bx bx-sun icon-sun"></i>
                    <i class="bx bx-moon icon-moon"></i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="flex-grow-1">
            <span class="fw-semibold d-block">
              {{ thisUser.firstName }} {{ thisUser.lastName }}
            </span>

            <!-- <span class="d-block">
                              {{ 'Username' | translate }} :
                              <small>
                                  {{ thisUser.username }}
                              </small>
                          </span>  -->

            <!-- <span class="d-block">
                              {{ 'DrugStore' | translate }} :
                              <small>
                                  {{ thisUser.drugStoreName }}
                              </small>
                          </span> 
                           -->

            <!-- <span class="d-block">
              {{ "Role" | translate }} :
              <small>
                {{ thisUser.roleName }}
              </small>
            </span> -->

            <span class="d-block">
              {{ "Position" | translate }} :
              <small>
                {{ thisUser.positionName }}
              </small>
            </span>
          </div>
        </div>
      </a>
    </li>
    <li>
      <div class="dropdown-divider"></div>
    </li>
    <li>
      <a class="dropdown-item" [routerLink]="userProfile">
        <i class="bx bx-user me-2"></i>
        <span class="align-middle">
          {{ "UserLink.Profile" | translate }}
        </span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" [routerLink]="'UserAccountSetting'">
        <i class="bx bx-cog me-2"></i>
        <span class="align-middle">
          {{ "UserLink.Settings" | translate }}
        </span>
      </a>
    </li>
    <li>
      <a class="nav-link hide-arrow" [routerLink]="['\Calender']">
        <i class="bx bx-calendar me-2 ms-2"></i>
        <span class="align-middle">
          {{ "Calender" | translate }}
        </span>
      </a>
    </li>
    <li>
      <div class="dropdown-divider"></div>
    </li>
    <li>
      <a class="dropdown-item" [routerLink]="helpCenter">
        <i class="bx bx-support me-2"></i>
        <span class="align-middle">
          {{ "UserLink.Help" | translate }}
        </span>
      </a>
    </li>
    <li>
      <div class="dropdown-divider"></div>
    </li>
    <li>
      <a class="dropdown-item" routerLink="/login">
        <i class="bx bx-power-off me-2"></i>
        <span class="align-middle">
          {{ "Logout" | translate }}
        </span>
      </a>
    </li>
  </ul>
</li>
